"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const SymfonyRouter_1 = __importDefault(require("@react/common/SymfonyRouter/SymfonyRouter"));
const FilterStateKeysEnum_1 = __importDefault(require("@react/web/Listing/Filter/FilterStateKeysEnum"));
const SortingTypes_1 = __importDefault(require("@react/web/Listing/Sorting/SortingTypes"));
const URL_PARAMETERS = {
    CAR_DETAIL_BACK_URL: 'car-detail-back-link',
    SORT_BY: 'radit-od',
};
const PageTitleDescription = {
    filtered: {
        description: 'Operativní leasing %s pro firmy, podnikatele i soukromé osoby. Vyberte si nové auto a jednoduše jezděte.',
        title: 'Operativní leasing %s | Driveto.cz',
    },
    unfiltered: {
        description: 'Operativní leasing aut pro firmy, podnikatele i soukromé osoby. Vyberte si nové auto a jednoduše jezděte.',
        title: 'Nabídka aut na operativní leasing | Driveto.cz',
    },
};
function getUrl() {
    return new URL(window.location.href);
}
class PageUrlHelper {
    static getSortByFromUrl() {
        const sortBy = getUrl().searchParams.get(URL_PARAMETERS.SORT_BY);
        return sortBy || SortingTypes_1.default.BEST_SELLING;
    }
    static getCarListingMergedOfferUrl(listingOffer) {
        const url = getUrl();
        url.pathname = this.getMergedOfferUrl(listingOffer);
        return url.href;
    }
    static getCarListingMergedOfferUrlWithoutFilters(listingOffer) {
        const url = new URL(this.getCarListingMergedOfferUrl(listingOffer));
        this.resetSearchParams(url);
        return url.href;
    }
    static hasCarDetailBackLinkQueryParam() {
        return getUrl().searchParams.get(URL_PARAMETERS.CAR_DETAIL_BACK_URL) === '1';
    }
    static removeCarDetailBackUrlParam() {
        const url = getUrl();
        url.searchParams.delete(URL_PARAMETERS.CAR_DETAIL_BACK_URL);
        window.history.replaceState({}, document.title, url.href);
    }
    static pageReplaceHistory(filterFormData) {
        window.history.replaceState(filterFormData, document.title, getUrl().href);
    }
    static pagePushHistory(filterFormData, sortBy, mergedCarListingOffer) {
        const url = getUrl();
        const queryString = url.search;
        const urlSearchParams = new URLSearchParams(queryString);
        let pageTitle = PageTitleDescription.unfiltered.title;
        let pageDescription = PageTitleDescription.unfiltered.description;
        this.resetSearchParams(url);
        if (urlSearchParams[URL_PARAMETERS.SORT_BY] !== null && sortBy === SortingTypes_1.default.CHEAPEST) {
            url.searchParams.set(URL_PARAMETERS.SORT_BY, sortBy);
        }
        else {
            url.searchParams.delete(URL_PARAMETERS.SORT_BY);
        }
        if (mergedCarListingOffer !== null) {
            url.pathname = this.getMergedOfferUrl(mergedCarListingOffer);
            pageTitle = PageTitleDescription.filtered.title.replace('%s', mergedCarListingOffer.modelFullName);
            pageDescription = PageTitleDescription.filtered.description.replace('%s', mergedCarListingOffer.modelFullName);
            Object.keys(filterFormData).forEach((key) => {
                if (key !== FilterStateKeysEnum_1.default.make
                    && key !== FilterStateKeysEnum_1.default.body
                    && key !== FilterStateKeysEnum_1.default.model) {
                    filterFormData[key].forEach((item) => {
                        this.searchParamsAppendItem(url, key, item);
                    });
                }
            });
        }
        else {
            url.pathname = SymfonyRouter_1.default.getRoute('subscription_listing', {});
            Object.keys(filterFormData).forEach((key) => {
                if (key === FilterStateKeysEnum_1.default.make) {
                    const selectedMakes = filterFormData.getSelectedMakes();
                    if (selectedMakes.length === 0) {
                        url.pathname = SymfonyRouter_1.default.getRoute('subscription_listing', {});
                    }
                    if (selectedMakes.length === 1) {
                        pageTitle = PageTitleDescription.filtered.title.replace('%s', selectedMakes[0].label);
                        pageDescription = PageTitleDescription.filtered.description.replace('%s', selectedMakes[0].label);
                        url.pathname = SymfonyRouter_1.default.getRoute('subscription_listing.with_make', {
                            makeSlug: selectedMakes[0].value,
                        });
                    }
                    if (selectedMakes.length > 1) {
                        filterFormData.make.forEach((item) => {
                            this.searchParamsAppendItem(url, key, item);
                        });
                    }
                }
                else {
                    filterFormData[key].forEach((item) => {
                        this.searchParamsAppendItem(url, key, item);
                    });
                }
            });
        }
        document.title = pageTitle;
        const pageDescriptionElement = document.querySelector('meta[name="description"]');
        const canonical = document.querySelector('link[rel="canonical"]');
        if (pageDescriptionElement !== null) {
            pageDescriptionElement.setAttribute('content', pageDescription);
        }
        if (canonical !== null) {
            canonical.href = url.pathname;
        }
        url.searchParams.sort();
        window.history.pushState(filterFormData, pageTitle, decodeURI(url.href));
    }
    static searchParamsAppendItem(url, key, item) {
        if (item.active === true) {
            url.searchParams.append(`${key}[]`, item.value);
        }
    }
    static resetSearchParams(url) {
        url.search = '';
    }
    static getMergedOfferUrl(listingOffer) {
        return SymfonyRouter_1.default.getRoute('subscription_listing.with_make_model_body', {
            bodyType: listingOffer.bodyType,
            makeSlug: listingOffer.makeSlug,
            modelSlug: listingOffer.modelSlug,
        });
    }
}
exports.default = PageUrlHelper;
